import React from "react";
import {
  Breadcrumb,
  Callout,
  Checkbox,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  DirectionalHint,
  Fabric,
  IBasePickerSuggestionsProps,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  IDropdownOption,
  ITag,
  Link,
  // MarqueeSelection,
  PrimaryButton,
  Selection,
  SelectionMode,
  Stack,
  TagPicker,
  Text,
} from "@fluentui/react";
import { mdiDotsVertical } from "@mdi/js";
import { useHistory, useParams } from "react-router-dom";
import { IAdmin, IPreviousMeeting } from "../../../vm";
import {
  API_URL,
  childrenGap,
  childrenGap8,
  MEETINGS_LOCATION_DICT,
  MEETINGS_OWNER_DICT,
  MEETINGS_STATUS_DICT,
} from "../../common/Constants";
import NoDataTile from "../../common/NoDataTile";
import Icon from "@mdi/react";
import {
  deletePreviousMeeting,
  getAllCustomers,
  getPreviousMeetings,
  getPreviousMeetingsExcel,
} from "../../../services/customers/CustomerService";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import moment from "moment";
import { Loading } from "../../../services/Loading";
import ManagePmDialog from "./ManagePmDialog";
import { getToken, parseJwt } from "../../../services/UtilService";
import { getAllAdmins, getCemAssignToACustomer } from "../../../services/datacenter/DataCenterManagerService";
import ManagePmSendEmailDialog from "./ManagePmSendEmailDialog";
import TotalNumbers from "../../common/TotalNumbers";

// export const calculateAging = (previousMeeting: IPreviousMeeting) => {
//   let aging: number | string = "N/A";
//   if (previousMeeting.meetingDate && !isNaN(Date.parse(previousMeeting.meetingDate as any))) {
//     if (previousMeeting.status === "closed") {
//       if (previousMeeting.completionDate && !isNaN(Date.parse(previousMeeting.completionDate as any))) aging = moment(previousMeeting.completionDate).diff(moment(previousMeeting.meetingDate), "days");
//     } else {
//       aging = moment().diff(moment(previousMeeting.meetingDate), "days")
//     }
//   }
//   return aging;
// }

export interface PreviousMeetingProps { }

const PreviousMeeting: React.FC<PreviousMeetingProps> = () => {
  // custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const tokenData = parseJwt()

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    previousMeetings: [],
    // allDatacenterDropdown: [],
    searchObj: {
      customerId: params.customerId,
      // status: [],
      sortBy: "meetingDate",
      sortOrder: "desc"
    },
    manageAcDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
      isStepTwoView: false
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    previousMeetings: IPreviousMeeting[];
    // allDatacenterDropdown: IDropdownOption[];
    searchObj: {
      customerId: string;
      // status: string[];
      sortBy: "meetingDate" | "noOfActionItems" | "noOfOpenItems" | "noOfWipItems" | "noOfClosedItems";
      sortOrder: "asc" | "desc"
    };
    manageAcDialog: {
      isOpen: boolean;
      index?: number;
      data?: IPreviousMeeting;
      isStepTwoView: boolean
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IPreviousMeeting;
    };
  });
  const [selectedMeetingIds, setSelectedMeetingIds] = React.useState([] as string[]);
  const [isSendEmailDialogOpen, setIsSendEmailDialogOpen] = React.useState(false as boolean);
  const [customer, setCustomer] = React.useState({
    isLoading: false,
    customer: {
      name: "",
    },
  } as {
    isLoading: boolean;
    customer: any;
  });

  const [users, setUsers] = React.useState([] as IDropdownOption[]); // only have cem role = 2
  const [usersDict, setUsersDict] = React.useState({} as { [key: string]: IAdmin }); // only have cem role = 2
  const [isUserLoading, setUserLoading] = React.useState(false as boolean);

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getAllPreviousMeeting();
      await getACustomer();
      await getCemUser();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setCustomer({ ...customer, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result?.success) {
      setCustomer({
        ...customer,
        customer: result.data[0],
        isLoading: false,
      });
    } else {
      setCustomer({ ...customer, isLoading: false });
    }
  };

  //   const getDatacenters = async () => {
  //     setState({ ...state, isLoading: false });

  //     let result = await getAllDataCenters();
  //     if (result?.success) {
  //       let allDatacenterDropdown: IDropdownOption[] = [];
  //       result.data.forEach((item) => {
  //         allDatacenterDropdown.push({
  //           key: item._id as string,
  //           text: item.name,
  //         });
  //       });

  //       datacenterDict = result.data.reduce((acc: any, d) => {
  //         acc[d._id as string] = d.name;
  //         return acc;
  //       }, {});
  //       console.log("datacen", datacenterDict);

  //       let obj = {
  //         ...state,
  //         allDatacenterDropdown,
  //         datacenterDict,
  //         isLoading: false,
  //       };
  //       setState(obj);
  //       getAllServiceDetails("", obj);
  //     } else {
  //       setState({ ...state, isLoading: false });
  //       showToast(
  //         result?.message || "Error while getting all datacenters",
  //         "error"
  //       );
  //     }
  //   };

  const getAllPreviousMeeting = async (search?: typeof state.searchObj, manageAcDialog?: typeof state.manageAcDialog) => {
    let searchObj = { ...state.searchObj };
    let manageAcDialogObj = { ...state.manageAcDialog };
    if (search) {
      searchObj = { ...searchObj, ...search };
    }
    if (manageAcDialog) {
      manageAcDialogObj = { ...manageAcDialogObj, ...manageAcDialog };
    }
    if (search) {
      searchObj = { ...searchObj, ...search };
    }
    setState({ ...state, isLoading: true });

    let result = await getPreviousMeetings(searchObj);
    if (result?.success) {
      setSelectedMeetingIds([]);
      setState({
        ...state,
        searchObj,
        previousMeetings: result.data,
        manageAcDialog: manageAcDialogObj,
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting customer meetings",
        "error"
      );
    }
  };

  const getCemUser = async () => {
    setUserLoading(true);
    let result = await getCemAssignToACustomer([params.customerId]);
    if (result?.success) {
      let data = result.data[params.customerId] || [];
      const dict: any = {};
      const listArray = data.map((d: any) => {
        dict[d._id] = d;
        return { key: d._id, text: d.name };
      });
      setUsersDict(dict);
      setUsers(listArray);
    };
    setUserLoading(false);
  };

  const handleDialogOpen = (isOpen: boolean, index?: number, isStepTwoView?: boolean) => {
    let previousMeetings = undefined;
    if (index !== undefined) {
      previousMeetings = { ...state.previousMeetings[index] };
      // previousMeetings = { ...state.previousMeetings[index], customerName: customer.customer.name };
    }
    setState({
      ...state,
      manageAcDialog: {
        isOpen,
        index,
        data: previousMeetings,
        isStepTwoView: isStepTwoView as boolean
      },
    });
  };

  const handleDialogClose = async (data: IPreviousMeeting) => {
    // let previousMeetings = [...state.previousMeetings];
    const manageAcDialog = {
      isOpen: false,
      index: undefined,
      data: undefined,
      isStepTwoView: false
    };
    if (data) {
      // if (state.manageAcDialog.index !== undefined) {
      //   // previousMeetings[state.manageAcDialog.index] = data;
      //   showToast("Customer Meeting updated successfully", "success");
      // } else {
      //   // previousMeetings.unshift(data);
      //   showToast("Customer Meeting added successfully", "success");
      // }
      await getAllPreviousMeeting(undefined, manageAcDialog);
    } else {
      setState({
        ...state,
        manageAcDialog,
      });
    }
  };

  const handleEmailDialogOpenClose = (isOpen: boolean, isSendEmail?: boolean) => {
    setIsSendEmailDialogOpen(isOpen);
    if (isSendEmail) setSelectedMeetingIds([]);
  }

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const deletePm = async (item: IPreviousMeeting, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete customer meeting",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deletePreviousMeeting(item);
        if (result?.success) {
          showToast("Customer Meeting deleted successfully", "success");
          let previousMeetings = [...state.previousMeetings];
          previousMeetings.splice(index, 1);
          setState({
            ...state,
            previousMeetings,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting customer meeting",
            "error"
          );
        }
      }
    );
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return ((tokenData.isAdmin && tokenData.role === 0) || item.userId === tokenData._id ? (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color="#135c8a"
            />
          </span>
        ) : (
          <></>
        )
          // <Stack horizontal>
          //   <TooltipHost
          //     content={`Edit Previous Meeting`}
          //     id={`editEm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => handleDialogOpen(true, index)}>
          //       <Icon
          //         path={mdiPencilOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={`Delete Previous Meeting`}
          //     id={`deleteEm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => deleteSd(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      case "sttParticipant":
        return <span>{`${item.sttParticipantName} (${item.sttParticipantEmail})`}</span>;
      case "customerParticipant":
        return <span>{`${item.customerParticipantName} (${item.customerParticipantEmail})`}</span>;
      case "meetingDate":
        return <span>{item.meetingDate ? moment(item.meetingDate).format("DD/MM/YYYY HH:mm A") : "NA"}</span>;
      case "userId":
        return <span>{usersDict[item.userId]?.name || "NA"}</span>;
      case "noOfActionItems":
        return <Link style={{ fontWeight: 600, textDecoration: "underline" }} onClick={() => handleDialogOpen(true, index, true)}>{item.noOfActionItems}</Link>;
      case "checkbox":
        return (
          (tokenData.isAdmin && tokenData.role === 0) || item.userId === tokenData._id ?
            <Checkbox
              checked={selectedMeetingIds.includes(item._id)}
              onChange={(e, v) => {
                let meetingIds = [...selectedMeetingIds];
                const index = meetingIds.findIndex((d) => d === item._id);
                if (index !== -1) {
                  meetingIds.splice(index, 1);
                } else {
                  meetingIds.push(item._id);
                }
                setSelectedMeetingIds(meetingIds);
              }}
            /> : <></>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }
      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  // const _selection = new Selection({
  //   onSelectionChanged: () => {
  //     const selectedItems = _selection.getSelection();
  //     const ids = selectedItems.map((d: any) => d._id);
  //     setSelectedMeetingIds(ids);
  //   },
  // });

  const onColumnClick = async (ev: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => {
    let searchObj = { ...state.searchObj };
    if (searchObj.sortBy === column.key) {
      searchObj.sortOrder = searchObj.sortOrder === "desc" ? "asc" : "desc";
    } else {
      searchObj.sortBy = column.key as any;
      searchObj.sortOrder = "asc";
    }
    await getAllPreviousMeeting(searchObj);
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IPreviousMeeting
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  const statusPickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No status found",
  };

  const filterSuggestedTags = (filterText: string, tagList: ITag[]): ITag[] => {
    let allStatusTag = Object.keys(MEETINGS_STATUS_DICT).map((d) => ({ key: d, name: MEETINGS_STATUS_DICT[d] }));

    return filterText
      ? allStatusTag.filter(
        (tag) =>
          tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
          !listContainsTagList(tag, tagList)
      )
      : [];
  };

  const showAllTags = (selectedItems?: ITag[] | undefined) => {
    let allStatusTag = Object.keys(MEETINGS_STATUS_DICT).map((d) => ({ key: d, name: MEETINGS_STATUS_DICT[d] }));

    return removeDuplicates(allStatusTag, selectedItems);
  };

  function removeDuplicates(tagList: ITag[], tags?: ITag[]) {
    return tagList.filter((tag) => !listContainsTagList(tag, tags));
  }

  const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
    if (!tagList || !tagList.length || tagList.length === 0) {
      return false;
    }
    return tagList.some((compareTag) => compareTag.key === tag.key);
  };

  const downloadReport = async () => {
    const result = await getPreviousMeetingsExcel(state.searchObj);
    let xlsx = await result.blob();
    const xlFile = await new Blob([xlsx], {
      type: "application/vnd.openxmlformats",
    });
    const xlFileURL = await URL.createObjectURL(xlFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = xlFileURL;
    a.download = `MOR Customer Meetings List for ${customer.customer.name || ""}.xlsx`;
    a.click();
  };

  return (
    <React.Fragment>
      {(state.isLoading || customer.isLoading || isUserLoading) && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: customer.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${customer.customer._id}`);
                },
              },
              {
                text: "Customer Meetings",
                key: "customer-meetings",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        {/* <Stack.Item>
          <TagPicker
            selectedItems={state.searchObj.status.map((d) => ({ key: d, name: MEETINGS_STATUS_DICT[d] }))}
            removeButtonAriaLabel="Remove"
            onResolveSuggestions={filterSuggestedTags as any}
            pickerSuggestionsProps={statusPickerSuggestionsProps}
            onEmptyResolveSuggestions={showAllTags}
            inputProps={{
              placeholder: "Select a status",
            }}
            styles={{ root: { maxWidth: "520px" } }}
            onChange={async (items: any) => {
              let status: string[] = [];
              items.forEach((i: any) => {
                status.push(i.key);
              });
              await getAllPreviousMeeting({ ...state.searchObj, status });
            }}
          />
        </Stack.Item> */}
        <Stack.Item>
          <Stack
            horizontal
            wrap
            tokens={childrenGap}
            horizontalAlign="space-between"
            verticalAlign="center"
          >
            {/* <Stack.Item>
              <Stack
                horizontal
                wrap
                tokens={childrenGap}
                horizontalAlign="start"
              > */}
            {/* <Stack.Item>
                  <Dropdown
                    placeholder="Select a Datacenter"
                    selectedKey={state.searchObj.datacenterId}
                    styles={{ dropdown: { width: 250 } }}
                    options={state.allDatacenterDropdown}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        // let options: IDropdownOption[] = [
                        //   { key: "all", text: "All" } ]
                        // ;
                        // let allDatacenterDropdown = [
                        //   ...state.allDatacenterDropdown,
                        // ];
                        // allDatacenterDropdown = [ ...options, allDatacenterDropdown]
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            datacenterId: v.key as string,
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={onSearch} />
                </Stack.Item> */}
            {/* </Stack>
            </Stack.Item> */}
            <Stack.Item>
              <TotalNumbers value={state.previousMeetings.length} />
            </Stack.Item>
            <Stack.Item>
              <Stack horizontal tokens={childrenGap} wrap>
                {tokenData.isAdmin && [0, 2].includes(tokenData.role) && selectedMeetingIds.length > 0 && (
                  <Stack.Item>
                    <PrimaryButton text="Send Email" onClick={() => handleEmailDialogOpenClose(true)} />
                  </Stack.Item>
                )}
                <Stack.Item>
                  <PrimaryButton text="Export" onClick={downloadReport} disabled={state.previousMeetings.length === 0} />
                </Stack.Item>
                {tokenData.isAdmin && [0, 2].includes(tokenData.role) && (
                  // {![2, 4].includes(tokenData.role) && (

                  <Stack.Item>
                    <PrimaryButton
                      text="Add Customer Meeting"
                      onClick={() => handleDialogOpen(true)}
                      className="borderless-btn bg-white"
                    />
                  </Stack.Item>
                )}
              </Stack>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.previousMeetings && state.previousMeetings.length > 0 ? (
            // <MarqueeSelection selection={_selection}>
            <Fabric>
              <DetailsList
                items={state.previousMeetings}
                columns={tokenData.isAdmin && [0, 2].includes(tokenData.role) ? [
                  // columns={![2, 4].includes(tokenData.role) ? [
                  {
                    key: "checkbox",
                    name: "Select",
                    fieldName: "checkbox",
                    minWidth: 50,
                    maxWidth: 50,
                    isResizable: false,
                  },
                  {
                    key: "actions",
                    name: "Actions",
                    fieldName: "actions",
                    minWidth: 60,
                    maxWidth: 60,
                    isResizable: true,
                  },
                  {
                    key: "meetingDate",
                    name: "Meeting Date",
                    fieldName: "meetingDate",
                    minWidth: 150,
                    maxWidth: 200,
                    isResizable: true,
                    isSorted: state.searchObj.sortBy === "meetingDate",
                    isSortedDescending: state.searchObj.sortOrder === "desc",
                    onColumnClick: onColumnClick
                  },
                  {
                    key: "sttParticipant",
                    name: "STT Participant (Name, Email)",
                    fieldName: "sttParticipant",
                    minWidth: 200,
                    maxWidth: 250,
                    isResizable: true,
                  },
                  {
                    key: "customerParticipant",
                    name: "Customer Participant (Name, Email)",
                    fieldName: "customerParticipant",
                    minWidth: 250,
                    maxWidth: 300,
                    isResizable: true,
                  },
                  {
                    key: "noOfActionItems",
                    name: "No Of Action Items",
                    fieldName: "noOfActionItems",
                    minWidth: 140,
                    maxWidth: 180,
                    isResizable: true,
                  },
                  {
                    key: "noOfOpenItems",
                    name: "Open",
                    fieldName: "noOfOpenItems",
                    minWidth: 70,
                    maxWidth: 70,
                    isResizable: true,
                  },
                  {
                    key: "noOfWipItems",
                    name: "Work In Progress",
                    fieldName: "noOfWipItems",
                    minWidth: 135,
                    maxWidth: 135,
                    isResizable: true,
                  },
                  {
                    key: "noOfClosedItems",
                    name: "Closed",
                    fieldName: "noOfClosedItems",
                    minWidth: 70,
                    maxWidth: 70,
                    isResizable: true,
                  },
                  {
                    key: "noOfUnderObservationItems",
                    name: "Under Observation",
                    fieldName: "noOfUnderObservationItems",
                    minWidth: 140,
                    maxWidth: 140,
                    isResizable: true,
                  },
                  {
                    key: "userId",
                    name: "Added By",
                    fieldName: "userId",
                    minWidth: 170,
                    maxWidth: 220,
                    isResizable: true,
                  },
                ] : [
                  {
                    key: "meetingDate",
                    name: "Meeting Date",
                    fieldName: "meetingDate",
                    minWidth: 150,
                    maxWidth: 200,
                    isResizable: true,
                    isSorted: state.searchObj.sortBy === "meetingDate",
                    isSortedDescending: state.searchObj.sortOrder === "desc",
                    onColumnClick: onColumnClick
                  },
                  {
                    key: "sttParticipant",
                    name: "STT Participant (Name, Email)",
                    fieldName: "sttParticipant",
                    minWidth: 200,
                    maxWidth: 250,
                    isResizable: true,
                  },
                  {
                    key: "customerParticipant",
                    name: "Customer Participant (Name, Email)",
                    fieldName: "customerParticipant",
                    minWidth: 250,
                    maxWidth: 300,
                    isResizable: true,
                  },
                  {
                    key: "noOfActionItems",
                    name: "No Of Action Items",
                    fieldName: "noOfActionItems",
                    minWidth: 140,
                    maxWidth: 180,
                    isResizable: true,
                  },
                  {
                    key: "noOfOpenItems",
                    name: "Open",
                    fieldName: "noOfOpenItems",
                    minWidth: 70,
                    maxWidth: 70,
                    isResizable: true,
                  },
                  {
                    key: "noOfWipItems",
                    name: "Work In Progress",
                    fieldName: "noOfWipItems",
                    minWidth: 135,
                    maxWidth: 135,
                    isResizable: true,
                  },
                  {
                    key: "noOfClosedItems",
                    name: "Closed",
                    fieldName: "noOfClosedItems",
                    minWidth: 70,
                    maxWidth: 70,
                    isResizable: true,
                  },
                  {
                    key: "noOfUnderObservationItems",
                    name: "Under Observation",
                    fieldName: "noOfUnderObservationItems",
                    minWidth: 140,
                    maxWidth: 140,
                    isResizable: true,
                  },
                  {
                    key: "userId",
                    name: "Added By",
                    fieldName: "userId",
                    minWidth: 170,
                    maxWidth: 220,
                    isResizable: true,
                  },
                ]}
                compact={true}
                setKey="set"
                onRenderItemColumn={_renderItemColumn as any}
                layoutMode={DetailsListLayoutMode.justified}
                // selectionMode={[0, 2].includes(tokenData.role) ? SelectionMode.multiple : SelectionMode.none}
                selectionMode={SelectionMode.none}
                onRenderRow={_onRenderRow}
              // selection={_selection}
              // selectionPreservedOnEmptyClick={true}
              />
            </Fabric>
            // </MarqueeSelection>
          ) : (
            <NoDataTile title="No Customer Meetings Found for this Customer"></NoDataTile>
          )}
        </Stack.Item>
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  deletePm(
                    state.manageActionsCallout.data as IPreviousMeeting,
                    state.manageActionsCallout.index as number
                  );
                }}
                className="callout-options"
              >
                Delete
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageAcDialog.isOpen && (
        <ManagePmDialog
          data={state.manageAcDialog.data}
          handleLoading={handleLoading}
          handleDialogClose={(data: IPreviousMeeting) =>
            handleDialogClose(data)
          }
          customerId={params.customerId}
          userList={users}
          isStepTwoView={state.manageAcDialog.isStepTwoView}
          customerName={customer.customer.name}
        />
      )}
      {isSendEmailDialogOpen && (
        <ManagePmSendEmailDialog
          meetingIds={selectedMeetingIds}
          handleClose={(isSendEmail?: boolean) =>
            handleEmailDialogOpenClose(false, isSendEmail)
          }
          meetingList={state.previousMeetings}
        />
      )}
    </React.Fragment>
  );
};

export default PreviousMeeting;
